import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { AlarmShape } from '../../../../prop-types'
import * as PropTypes from 'prop-types'
import { alarmOperations } from '../../../../state/ducks/alarms'
import { connect } from 'react-redux'
import { Session } from '../../../../state/utils/session'
import { AlarmDetailsCard, AlarmTimelineCard, AlarmQueryCard } from '../../containers'

class AlarmDetailsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.props.getAlarm(this.props.match.params.alarm_id)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_ALARMS_PATH.replace(':client_id', this.state.session.getClientSession())}
                    >
                        Alarms
                    </NavLink>
                </li>
                <li>Alarm Details</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={this.props.alarm.name}
                        subTitle={'Alarm Details'}
                        paths={this.renderHeaderPaths}
                    />
                    <div className="content content-boxed">
                        <div className="row">
                            <div className="col-sm-12 col-lg-5">
                                {/* Details */}
                                <AlarmDetailsCard alarm={this.props.alarm}/>
                                {/* END Details */}
                            </div>
                            <div className="col-sm-12 col-lg-7">
                                {/* Query Data */}
                                <AlarmQueryCard alarm={this.props.alarm}/>
                                {/* END Query Data */}
                            </div>
                            <div className="col-sm-12 col-lg-7">
                                {/* Timeline */}
                                <AlarmTimelineCard alarm={this.props.alarm}/>
                                {/* END Timeline */}
                            </div>
                        </div>
                    </div>
                </PageContainerLayout>
            </>
    )
  }
}

// Set propTypes
AlarmDetailsPage.propTypes = {
  alarm: AlarmShape,
  getAlarmErrorResponse: PropTypes.object
}

// Set defaultProps
AlarmDetailsPage.defaultProps = {
  alarm: {},
  getAlarmErrorResponse: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  alarm: state.alarms.getAlarmReducer.data,
  isLoading: state.alarms.getAlarmReducer.loading,
  getAlarmErrorResponse: state.alarms.getAlarmReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  getAlarm: alarmOperations.get
}

// Export Class
const _AlarmDetailsPage = connect(mapStateToProps, mapDispatchToProps)(AlarmDetailsPage)
export { _AlarmDetailsPage as AlarmDetailsPage }
